











import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-checkbox',

})
export default class ICheckbox extends Vue {

  @Prop({type: [Boolean], default: false}) protected isCheck!: boolean

}

